import { getCurrentCode, getSecondsRemaining, formatCode } from '../../crypto.js';

/**
 * Live TOTP code display with countdown timer
 */
export class CodeDisplay {
  /**
   * @param {HTMLElement} container - Container element
   * @param {string} secret - Base32 encoded TOTP secret
   */
  constructor(container, secret) {
    this.container = container;
    this.secret = secret;
    this.interval = null;
    this.lastCode = null;
    this.render();
    this.startTimer();
  }

  /**
   * Render the code display
   */
  render() {
    const code = getCurrentCode(this.secret);
    const remaining = getSecondsRemaining();
    const progress = (remaining / 30) * 100;

    // Format code with space in middle: "384 729"
    const formatted = formatCode(code);

    // Color based on time remaining
    let barClass = '';
    let textColor = 'text-green-600';
    if (remaining <= 5) {
      barClass = 'danger';
      textColor = 'text-red-600';
    } else if (remaining <= 10) {
      barClass = 'warning';
      textColor = 'text-amber-600';
    }

    // Add animation class when code changes
    const codeClass = this.lastCode !== null && this.lastCode !== code
      ? 'animate-pulse'
      : '';
    this.lastCode = code;

    this.container.innerHTML = `
      <div class="code-display bg-white rounded-2xl shadow-lg p-6 border border-slate-100">
        <div class="text-center mb-4">
          <div class="text-sm font-medium text-slate-500 mb-2">Current verification code</div>
          <div class="code-value ${codeClass}" style="color: #1e293b;">
            ${formatted}
          </div>
        </div>
        <div class="relative">
          <div class="w-full bg-slate-100 rounded-full overflow-hidden">
            <div class="timer-bar ${barClass}" style="width: ${progress}%"></div>
          </div>
          <div class="mt-2 text-center">
            <span class="text-sm font-medium ${textColor}">${remaining}s</span>
            <span class="text-sm text-slate-400 ml-1">until next code</span>
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Start the countdown timer
   */
  startTimer() {
    this.interval = setInterval(() => this.render(), 1000);
  }

  /**
   * Clean up interval when component is destroyed
   */
  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}
